interface SpiralIconProps {
  className?: string;
  /** ストランド1の色 (デフォルト: currentColor) */
  color1?: string;
  /** ストランド2の色 (デフォルト: currentColor) */
  color2?: string;
  /** ベースペアの色 (デフォルト: currentColor) */
  pairColor?: string;
}

/**
 * DNA二重螺旋をモチーフにした locomoco のロゴアイコン
 *
 * 2本のストランドがsinカーブ状に絡み合い、
 * ベースペア（横線）が等間隔に架かる構造。
 */
export default function SpiralIcon({
  className,
  color1 = 'currentColor',
  color2 = 'currentColor',
  pairColor = 'currentColor',
}: SpiralIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* ──────────────────────────────────────────
          ベースペア（横の橋）: 両ストランドを結ぶ
          y=3.5, 9.5, 19, 28.5, 34.5 に配置
      ────────────────────────────────────────── */}
      <line x1="4.5" y1="3.5"  x2="15.5" y2="3.5"  stroke={pairColor} strokeWidth="1.4" strokeLinecap="round" opacity="0.35" />
      <line x1="4"   y1="9.5"  x2="16"   y2="9.5"  stroke={pairColor} strokeWidth="1.6" strokeLinecap="round" opacity="0.50" />
      <line x1="5"   y1="15"   x2="15"   y2="15"   stroke={pairColor} strokeWidth="1.4" strokeLinecap="round" opacity="0.35" />
      <line x1="10"  y1="19"   x2="10"   y2="19"   stroke={pairColor} strokeWidth="0"   strokeLinecap="round" opacity="0" />
      <line x1="5"   y1="23"   x2="15"   y2="23"   stroke={pairColor} strokeWidth="1.4" strokeLinecap="round" opacity="0.35" />
      <line x1="4"   y1="28.5" x2="16"   y2="28.5" stroke={pairColor} strokeWidth="1.6" strokeLinecap="round" opacity="0.50" />
      <line x1="4.5" y1="34.5" x2="15.5" y2="34.5" stroke={pairColor} strokeWidth="1.4" strokeLinecap="round" opacity="0.35" />

      {/* ──────────────────────────────────────────
          ストランド2（背面）: 右→左→右
          少し細め・半透明で奥行きを表現
      ────────────────────────────────────────── */}
      <path
        d="M10,0 C10,3 4,6 4,9.5 C4,13 10,16 10,19 C10,22 16,25 16,28.5 C16,32 10,35 10,38"
        stroke={color2}
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.55"
      />

      {/* ──────────────────────────────────────────
          ストランド1（前面）: 左→右→左
          太め・全不透明でメインストランドを強調
      ────────────────────────────────────────── */}
      <path
        d="M10,0 C10,3 16,6 16,9.5 C16,13 10,16 10,19 C10,22 4,25 4,28.5 C4,32 10,35 10,38"
        stroke={color1}
        strokeWidth="2.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
